const initPopupEnquiry = () => {
  const closeBtns = document.querySelectorAll<HTMLElement>(
    "[data-popup-enquiry-close]"
  );
  const openBtns = document.querySelectorAll<HTMLElement>(
    "[data-popup-enquiry-open]"
  );

  const popup = document.getElementById("popup-enquiry");
  const formStatus = document.querySelector<HTMLElement>(
    ".pb__enquiry-form .form-status"
  );

  if (formStatus) {
    const enquireFormStatusContainer = document.querySelector<HTMLElement>(
      ".enquire-form-status-container"
    );
    if (enquireFormStatusContainer) {
      enquireFormStatusContainer.appendChild(formStatus.cloneNode(true));
    }
  }

  if (popup) {
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.remove("is-fixed", "is-visible", "active");
      });
    });

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.add("is-fixed", "is-visible", "active");
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initPopupEnquiry();
});
